module.exports = __webpack_public_path__ + "static/2_1_search-2_HR-050e2c8abb45a503fe1e3d2ff3f7621e.svg";